module.exports = __webpack_public_path__ + "static/media/itunes.78c96986.jpg";